import Cookies from 'js-cookie'
export const SessionHandler = () => {
  const jwt = Cookies.get('cookie_token')

  var session_token = Cookies.get('session_token')

  //console.log('session_token:::'+session_token);
  //Check except login and login callback i.e. for protected routes.
  if(session_token){
    return true;
  } else {
    return false;
  }

}